import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe, DatePipe, getCurrencySymbol, PercentPipe } from '@angular/common';

@Pipe({
    name: 'formatter',
    standalone: false
})
export class Formatter implements PipeTransform {
  transform(value: any, formatString: string): any {
    if (formatString === 'date' && value) {

      try {
        const datePipe = new DatePipe('en-IN');
        return datePipe.transform(value, 'yyyy-MM-dd', '', 'en-IN');
      }
      catch (error) {
        // for DD-MM-YYYY date type.
        let splitDate = value.split("-");
        if (!splitDate || splitDate.length < 3) {
          // for DD/MM/YYYY date type.
          splitDate = [];
          splitDate = value.split("/");
        }
        if (splitDate && splitDate.length >= 3) {
          let isoFormatDate = splitDate.reverse().join("-");
          const datePipe = new DatePipe('en-IN');
          return datePipe.transform(isoFormatDate, 'yyyy-MM-dd', '', 'en-IN');
        }
        return value;
      }
    }

    // to format the date in "DD-MM-YYYYY"
    if (formatString === 'date-2' && value) {

      try {
        const datePipe = new DatePipe('en-IN');
        return datePipe.transform(value, 'dd-MM-yyyy', '', 'en-IN');
      }
      catch (error) {
        let splitDate = value.split("-");
        if (!splitDate || splitDate.length < 3) {
          splitDate = [];
          splitDate = value.split("/");
        }
        if (splitDate && splitDate.length >= 3) {
          let isoFormatDate = splitDate.reverse().join("-");
          const datePipe = new DatePipe('en-IN');
          return datePipe.transform(isoFormatDate, 'dd-MM-yyyy', '', 'en-IN');
        }
        return value;
      }
    }
    if (formatString === 'dateTime' && value) {
      try {
        const datePipe = new DatePipe('en-IN');
        return datePipe.transform(value, 'd MMM y | h:mm a', '', 'en-IN');
      }
      catch (error) {
        // for DD-MM-YYYY date type.
        let splitDate = value.split("-");
        if (!splitDate || splitDate.length < 3) {
          // for DD/MM/YYYY date type.
          splitDate = [];
          splitDate = value.split("/");
        }
        if (splitDate && splitDate.length >= 3) {
          let isoFormatDate = splitDate.reverse().join("-");
          const datePipe = new DatePipe('en-IN');
          return datePipe.transform(isoFormatDate, 'd MMM y | h:mm a', '', 'en-IN');
        }
        return value;
      }
    }
    if (formatString == 'datetime' && value) {
      const datePipe = new DatePipe('en-IN');
      return datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss', '', 'en-IN');
    }
    if (formatString === 'currency' && value) {
      if (isNaN(value)) return value;
      return (
        getCurrencySymbol('INR', 'narrow') + ' ' +
        Math.round(Number(value)).toLocaleString('en-IN')
      );
    }
    if (formatString === 'currency-US' && value) {
      if (isNaN(value)) return value;
      return (
        getCurrencySymbol('INR', 'narrow') + ' ' +
        Math.round(Number(value)).toLocaleString('en-US')
      );
    }

    if (formatString === 'number' && value) {
      if (isNaN(value)) return value;
      const decimalPipe = new DecimalPipe('en-IN');
      return decimalPipe.transform(value, '1.2-2');
    }
    if (formatString === 'number-round' && value) {
      if (isNaN(value)) return value;
      return Math.round(Number(value)).toLocaleString('en-IN')
    }
    if (formatString === 'percentage' && value) {
      if (isNaN(value)) return value;
      const percentPipe = new PercentPipe('en-IN');
      const val = (value / 100);
      return percentPipe.transform(val, '1.0-0', 'en-IN');
    }
    //percent pipe with max 2digits after decimal points
    if (formatString === 'percent' && value) {
      if (isNaN(value)) return value;
      const percentPipe = new PercentPipe('en-IN');
      const val = (value / 100);
      return percentPipe.transform(val, '1.0-2', 'en-IN');
    }
    if (formatString === 'boolean') {
      if (value == 1) {
        return true;
      } if (value == 0) {
        return false
      }
    }
    if (formatString === 'statusFormatter') {
      if (value == 1) {
        return 'Active';
      } if (value == 0) {
        return 'Inactive'
      }
      else {
        return '-'
      }
    }
    if (formatString === 'yesNoFormatter') {
      if (value == 1) {
        return 'Yes';
      } if (value == 0) {
        return 'No'
      }
      else {
        return '-'
      }
    }
    else {
      return value;
    }
  }
}
